export function Cond({ children, when }: { children: React.ReactNode; when: boolean }) {
  return when ? <>{children}</> : null;
}
